
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import { Flex, IconButton, Stack, Text, useColorMode } from "@chakra-ui/react";
import AuthShell from "@/src/layouts/AuthShell";
import AuthContent from "@/src/components/AuthContent";
import useTranslation from "next-translate/useTranslation";
import ChooseAccountCard from "@/src/components/ChooseAccountCard";
import { AiOutlineUser, AiOutlineUserAdd } from "react-icons/ai";
import { useRouter } from "next/router";
import Logo from "@/src/components/Logo";
import CustomLink from "@/src/components/CustomLink";
// Helper pour nettoyer l'URL de redirection
const cleanRedirectUrl = (url) => {
    if (!url || typeof url !== "string" || url.trim() === "" || url === "undefined") {
        return null;
    }
    // Optionnel : valider que c'est une URL interne
    if (url.startsWith("/") && !url.includes("//")) {
        return url;
    }
    return null;
};
const Choose = () => {
    const router = useRouter();
    const { t } = useTranslation();
    const { colorMode } = useColorMode();
    const { redirect_url } = router.query;
    // Nettoie l'URL une fois pour toute
    const safeRedirectUrl = cleanRedirectUrl(redirect_url);
    const buildAuthUrl = (type) => {
        const baseUrl = `/account/auth/?type=${type}`;
        if (safeRedirectUrl) {
            return `${baseUrl}&redirect_url=${encodeURIComponent(safeRedirectUrl)}`;
        }
        return baseUrl;
    };
    return (<AuthShell>
      <AuthContent title={t("account:choose.page.title")} sub_title={t("account:choose.page.sub_title")} desc={t("account:choose.page.description")}>
        <ChooseAccountCard>
          <Flex wrap={"wrap"} gap={"8px"}>
            <Text fontWeight={"400"} fontSize={"26.0149px"} lineHeight={"39px"} textAlign={"center"} color={colorMode === "light" ? "#232323" : "white"} mb={"4px"}>
              {t("account:choose.card.welcome_text")}
            </Text>
            <CustomLink to={"/"} alignItems={"center"}>
              <Logo width={"215px"} height={"41px"} mb={1}/>
            </CustomLink>
          </Flex>
          <Stack direction={"row"} spacing={"33px"} py={8}>
            <Flex direction={"column"} justifyContent={"center"} alignItems={"center"} gap={"19px"}>
              <IconButton variant={"iconButton"} onClick={() => router.push(buildAuthUrl("manager"))} borderRadius={"20px"} size={"40px"} padding={"22px"} aria-label="Search database" icon={<AiOutlineUser size={"50px"}/>}/>
              <Text fontWeight={"300"} fontSize={"16px"} lineHeight={"24px"} textAlign={"center"} color={colorMode === "light" ? "inherit" : "white"}>
                {t("account:choose.card.register_manager")}
              </Text>
            </Flex>
            <Flex direction={"column"} justifyContent={"center"} alignItems={"center"} gap={"19px"}>
              <IconButton variant={"iconButton"} onClick={() => router.push(buildAuthUrl("collaborator"))} borderRadius={"20px"} size={"40px"} color={"#00B295"} padding={"22px"} aria-label="Search database" icon={<AiOutlineUserAdd size={"50px"}/>}/>

              <Text fontWeight={"300"} fontSize={"16px"} lineHeight={"24px"} textAlign={"center"} color={colorMode === "light" ? "inherit" : "white"}>
                {t("account:choose.card.register_collaborator")}
              </Text>
            </Flex>
          </Stack>
        </ChooseAccountCard>
      </AuthContent>
    </AuthShell>);
};
export default Choose;

    async function __Next_Translate__getStaticProps__1a1a753e858__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/account/choose',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1a753e858__ as getStaticProps }
  